// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 966 ? "dashboard" : chunkId) + "-legacy." + {"77":"102ea9d1","253":"29d62a40","278":"50b17f8a","307":"096ed5c7","313":"e8e0697a","358":"8c055ab1","360":"96602377","456":"929fdc42","566":"7f352a43","606":"c8fa44e2","700":"88910485","725":"162b2d1a","781":"91f74a75","966":"28beafda"}[chunkId] + ".js";
};